import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bar-2.svg'


const _withScopeId = n => (_pushScopeId("data-v-f9302f46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-between flex-column px-2" }
const _hoisted_2 = { class: "rounded-4 bg-white shadow my-lg-5 mt-5 my-3 p-lg-5 p-3" }
const _hoisted_3 = { class: "text-center title fw-bold mb-4 mt-4" }
const _hoisted_4 = { class: "description px-lg-5 mb-lg-5 mb-3" }
const _hoisted_5 = { class: "dashboard p-lg-5 px-2 py-4" }
const _hoisted_6 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "mb-lg-5 mb-4"
}
const _hoisted_8 = { class: "shadow position-relative bg-white rounded-4 px-sm-4 py-4 px-2 d-flex align-items-start text-break" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit",
  class: "me-2 cursor-pointer"
}, null, -1))
const _hoisted_10 = { class: "mt-6px w-100" }
const _hoisted_11 = { class: "h3-title fw-bold pb-2" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = { class: "d-flex align-content-center" }
const _hoisted_14 = { class: "item-name me-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "item-name text-break" }
const _hoisted_17 = { class: "d-flex align-content-center" }
const _hoisted_18 = { class: "item-name" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "item-date" }
const _hoisted_21 = { class: "d-flex justify-content-center" }
const _hoisted_22 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_23 = {
  key: 0,
  class: "shadow position-relative bg-white rounded-4 p-4 d-flex align-items-start mb-4"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit",
  class: "me-2 cursor-pointer"
}, null, -1))
const _hoisted_25 = { class: "mt-6px w-100" }
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "fs-6 fw-bold" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "item-date" }
const _hoisted_31 = { class: "d-flex justify-content-center" }

import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import Tabs, { Tab } from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import TargetTag from '@/components/target-tag/index.vue'
import AddWorkHistoryModal from '@/views/user/account/portfolio/components/AddWorkHistoryModal.vue'
// import EditIcon from '@/components/edit-icon/index.vue'
import Submenu from '@/components/submenu/index.vue'
import AddAffiliationModal from '@/views/user/account/portfolio/components/AddAffiliationModal.vue'
import DeleteModal from '@/views/user/account/portfolio/components/DeleteModal.vue'
import DeleteSuccessModal from '@/views/user/account/portfolio/components/DeleteSuccessModal.vue'
import DeleteActivity from '@/views/user/account/portfolio/components/DeleteActivity.vue'
import DeleteActivitySuccess from '@/views/user/account/portfolio/components/DeleteActivitySuccess.vue'
import AddActivityModal from '@/views/user/account/portfolio/components/AddActivityModal.vue'
import { displayWorkingPeriod } from '@/constants/datepicker'
import { Modal } from 'bootstrap'
import { COMMUNITY_PORTFOLIOS_STORE, REGISTER_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'
import Draggable from 'vuedraggable'
import SubMenuAdmin from '@/components/submenu/subMenuAdmin.vue'

type AddAffiliationModalExposed = {
  onReset: () => void
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const portfolios = computed(() => store.getters[COMMUNITY_PORTFOLIOS_STORE.GETTERS.COMMUNITIES_PORTFOLIOS])
const keyAffiliationModal = ref(0)

const activities = computed(() => store.getters[COMMUNITY_PORTFOLIOS_STORE.GETTERS.ACTIVITIES_PORTFOLIOS])

const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])

const refAddAffiliationModal = ref<AddAffiliationModalExposed | null>(null)

const menu = computed(() => {
  return [
    { icon: '<i class="far fa-edit" />', title: translate('editWork'), onclick: handleAddWorkModal },
    { icon: '<i class="far fa-trash-alt" />', title: translate('deleteWork'), onclick: handleConfirmDeleteModal },
  ]
})

onMounted(() => {
  store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.SET_COMMUNITIES_PORTFOLIOS, router.currentRoute.value.params.id)
  store.dispatch(REGISTER_STORE.ACTIONS.SET_LIST_JOBS)
})

watch(
  () => route?.query?.tab,
  () => {
    // AddWorkHistoryModal will be clear when change tab
    // so force rerender AddAffiliationModal to refetch modalAddWorkModal in mounted hook
    if (route?.query?.tab == 'history') keyAffiliationModal.value += 1
  }
)

Array.prototype.swapItems = function (a, b) {
  this[a] = this.splice(b, 1, this[a])[0]
  return this
}

const idCorporation = ref('')
const idWork = ref('')
const errorCreateDepartment = ref<string>('')
const serverErrorDelete = ref<boolean>(false)

const idActivities = ref('')

const drag = ref(false)

const handleEndDrag = (e): void => {
  drag.value = false

  const sortData = {
    id: route.params?.id,
    payload: {
      id: portfolios.value.find((_, i) => i === e.oldDraggableIndex)?.id,
      new_position: portfolios.value.find((_, i) => i === e.newDraggableIndex)?.id,
    },
  }

  store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.UPDATE_ACTIVITIES_PORTFOLIOS_DRAG, { oldIndex: e.oldDraggableIndex, newIndex: e.newDraggableIndex, sortData: sortData })
}

const handleEndDragActivities = (e): void => {
  drag.value = false

  const sortData = {
    id: route.params?.id,
    payload: {
      id: activities.value.find((_, i) => i === e.oldDraggableIndex)?.id,
      new_position: activities.value.find((_, i) => i === e.newDraggableIndex)?.id,
    },
  }

  store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.UPDATE_ACTIVITIES_DRAG, { oldIndex: e.oldDraggableIndex, newIndex: e.newDraggableIndex, sortData: sortData })
}

// 2022/10/05 PhucNV Fix bug when edit work history, the major/minor category values not saved UAT#4566: SG43(Ph2-R20221007)
const resetDataEditFlag = ref(false)
const handleEditWork = (idParent: number | string, idChild: number | string): void => {
  idCorporation.value = idParent
  idWork.value = idChild
  resetDataEditFlag.value = !resetDataEditFlag.value
}

const getModalInstance = (selector: string): Modal | null => {
  const el = document.querySelector(selector)
  if (!el) return null
  return Modal.getInstance(el) || new Modal(el)
}

// Show modal addWorkModal
const handleAddWorkModal = () => {
  toogleModalAddWork('show')
}

// Show modal confirmDeleteModal
const handleConfirmDeleteModal = () => {
  const instance = getModalInstance('#confirmDeleteModal')
  instance?.show()
}
// Hide modal confirmDeleteModal
const hideConfirmDeleteModal = () => {
  const instance = getModalInstance('#confirmDeleteModal')
  instance?.hide()
}

const handleEditActivities = (id: number | string): void => {
  idActivities.value = id
}

const createDepartmentError = (status: string): void => {
  errorCreateDepartment.value = status
}

const deleteError = (status: boolean): void => {
  serverErrorDelete.value = status
}

const handleGetJob = (idParent: number, idChild: number): { parent: string; child: string } => {
  if (!listJobs.value.length) {
    return
  }
  const childJobs = listJobs?.value?.find((item: any) => item.id === idParent)
  return {
    parent: childJobs.name,
    child: childJobs?.child?.find((item: any) => item.id === idChild)?.name,
  }
}

const transitSettingProfile = (): void => {
  router.push(`/${route.path.split('/')[1]}/communities/${route.params?.id}/account/profile/setting`)
}

const toogleModalAddWork = (method: 'show' | 'hide') => {
  const instance = getModalInstance('#addWorkModal')
  if (instance) {
    instance[method]()
  }
}

const resetAffiliationModal = () => {
  refAddAffiliationModal.value?.onReset()
}

onMounted(() => {
  handleEditWork('', '')
  handleEditActivities('')
})
const tabs: Array<Tab> = [
  {
    title: translate('workExperience'),
    alias: 'history',
  },
  { title: translate('personalActivity'), alias: 'activity' },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translate)('SG43title')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SG43description')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Tabs, {
            tabs: tabs,
            "default-alias": 'history'
          }, {
            default: _withCtx(() => [
              _createVNode(TabPanel, {
                alias: 'history',
                keyName: 1
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(AddWorkHistoryModal, {
                      idCorporation: idCorporation.value,
                      idWork: idWork.value,
                      errorCreateDepartment: errorCreateDepartment.value,
                      handleEditWork: handleEditWork,
                      createDepartmentError: createDepartmentError,
                      resetDataEditFlag: resetDataEditFlag.value,
                      onToogleModalAddWork: toogleModalAddWork,
                      onResetAffiliationModal: resetAffiliationModal
                    }, null, 8, ["idCorporation", "idWork", "errorCreateDepartment", "resetDataEditFlag"])
                  ]),
                  _createVNode(_unref(Draggable), {
                    modelValue: _unref(portfolios),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(portfolios) ? (portfolios).value = $event : null)),
                    tag: "transition-group",
                    animation: 200,
                    group: "people",
                    onStart: _cache[1] || (_cache[1] = ($event: any) => (drag.value = true)),
                    onEnd: handleEndDrag,
                    delay: 100,
                    delayOnTouchOnly: true,
                    touchStartThreshold: 5,
                    "item-key": "id"
                  }, {
                    item: _withCtx(({ element }) => [
                      (element?.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _hoisted_9,
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("h3", _hoisted_11, _toDisplayString(element.name), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.portfolio_work_histories, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: "mb-4"
                                  }, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.department_name), 1),
                                          _hoisted_15,
                                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.position), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                          _createElementVNode("p", _hoisted_18, _toDisplayString(handleGetJob(item.job_type_parent_id, item.job_type_child_id)?.child), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createVNode(SubMenuAdmin, {
                                          menu: _unref(menu),
                                          onClick: () => handleEditWork(element.id, item.id)
                                        }, null, 8, ["menu", "onClick"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(displayWorkingPeriod)(item.start_period, item.end_period)), 1)
                                    ]),
                                    _createVNode(TargetTag, {
                                      data: item?.content,
                                      class: "item-description mb-0 text-break pe-4"
                                    }, null, 8, ["data"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(Button, {
                      title: _unref(translate)('back'),
                      type: 'secondary',
                      onClick: transitSettingProfile
                    }, null, 8, ["title"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(TabPanel, {
                alias: 'activity',
                keyName: 2
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(AddActivityModal, {
                      id: idActivities.value,
                      handleEditActivities: handleEditActivities
                    }, null, 8, ["id"])
                  ]),
                  _createVNode(_unref(Draggable), {
                    modelValue: _unref(activities),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(activities) ? (activities).value = $event : null)),
                    tag: "transition-group",
                    animation: 200,
                    group: "people",
                    onStart: _cache[3] || (_cache[3] = ($event: any) => (drag.value = true)),
                    onEnd: handleEndDragActivities,
                    delay: 100,
                    delayOnTouchOnly: true,
                    touchStartThreshold: 5,
                    "item-key": "id"
                  }, {
                    item: _withCtx(({ element }) => [
                      (element?.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("h3", _hoisted_27, _toDisplayString(element.title), 1),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (handleEditActivities(element.id))
                                }, [
                                  _createVNode(Submenu, {
                                    dataBs: [
                            ['modal', '#addActivity'],
                            ['modal', '#deleteActivity'],
                          ],
                                    menu: [{ title: _unref(translate)('editPersonalActivities') }, { title: _unref(translate)('removePersonalActivities') }]
                                  }, null, 8, ["menu"])
                                ], 8, _hoisted_28)
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(displayWorkingPeriod)(element.start_period, element.end_period)), 1)
                              ]),
                              _createVNode(TargetTag, {
                                data: element?.content,
                                class: "item-description text-break"
                              }, null, 8, ["data"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(Button, {
                      title: _unref(translate)('back'),
                      type: 'secondary',
                      onClick: transitSettingProfile
                    }, null, 8, ["title"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_unref(route)?.query?.tab !== 'activity')
      ? (_openBlock(), _createBlock(AddAffiliationModal, {
          createDepartmentError: createDepartmentError,
          key: keyAffiliationModal.value,
          ref: (_value, _refs) => {
            _refs['refAddAffiliationModal'] = _value
            refAddAffiliationModal.value = _value
          },
          onToogleModalAddWork: toogleModalAddWork
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(DeleteModal, {
      idWork: idWork.value,
      idCorporation: idCorporation.value,
      deleteError: deleteError,
      hideModalConfirm: hideConfirmDeleteModal
    }, null, 8, ["idWork", "idCorporation"]),
    _createVNode(DeleteSuccessModal, { serverErrorDelete: serverErrorDelete.value }, null, 8, ["serverErrorDelete"]),
    _createVNode(DeleteActivity, {
      id: idActivities.value,
      handleDelete: handleEditActivities,
      deleteError: deleteError
    }, null, 8, ["id"]),
    _createVNode(DeleteActivitySuccess, { serverErrorDelete: serverErrorDelete.value }, null, 8, ["serverErrorDelete"])
  ], 64))
}
}

})